import { Button } from '@/components/ui/button'

interface FeedNavTabsProps {
  value: 'feed' | 'profile'
  onChange: (val: 'feed' | 'profile') => void
}

export default function FeedNavTabs({ value, onChange }: FeedNavTabsProps) {
  return (
    <div className="flex space-x-1 bg-gray-100 p-1 rounded-lg">
      <Button
        onClick={() => onChange('feed')}
        className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
          value === 'feed'
            ? 'bg-blue-600 text-white shadow-sm hover:bg-blue-700'
            : 'bg-white text-gray-600 hover:bg-blue-50 hover:text-blue-700'
        }`}
      >
        ฟีด
      </Button>

      <Button
        onClick={() => onChange('profile')}
        className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
          value === 'profile'
            ? 'bg-blue-600 text-white shadow-sm hover:bg-blue-700'
            : 'bg-white text-gray-600 hover:bg-blue-50 hover:text-blue-700'
        }`}
      >
        โปรไฟล์
      </Button>
    </div>
  )
}
